import { UseFormReturn } from 'react-hook-form';

import { FormField, FormItem, FormMessage } from '@@/ui/primitives';
import { Field } from '../../../../schemas/entity';
import { CreateItemPayload } from '../../../../schemas/item';
import { DateTimeInput } from '../../../shared/field-inputs';

interface DatetimeFieldRendererProps {
  fieldKey: string;
  field: Field;
  form: UseFormReturn<CreateItemPayload['attributes']>;
  label: string;
  disabled?: boolean;
}

export function DatetimeFieldRenderer({ fieldKey, field, form, label, disabled = false }: DatetimeFieldRendererProps) {
  const definition = field.definition;

  if (definition.type !== 'date_time') {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name={fieldKey}
      render={({ field: formField }) => (
        <FormItem>
          <DateTimeInput
            value={formField.value ?? { timeZone: 'UTC', date: '', time: '' }}
            onChange={formField.onChange}
            label={label}
            disabled={disabled}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
